import axios from "axios";

export const loginHandler = async (user) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/signin", user,{
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const searchHandler = async (user) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/searchuser", user,{
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const currentUser = async (authtoken) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/current-user",
    {},
     {
        headers: {
            'authtoken' : 'bearer ' + authtoken,
        }
    });
}

export const logoutHandler = async (authtoken, data) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/signout", data,
     {
        headers: {
            'authtoken' : 'bearer ' + authtoken,
        }
    });
}

export const registerHandler = async (user) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/signup", user,{
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const loginonMobile = async (user) => {
    return await axios.post(process.env.REACT_APP_API_URL + "/signinmb", user,{
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

// export const statusIP = async () => {
//     return await axios.get(process.env.REACT_APP_GET_IP,{
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     });
// }

